var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.973 3.99935C14.4597 4.23268 13.9064 4.38602 13.333 4.45935C13.9197 4.10602 14.373 3.54602 14.5864 2.87268C14.033 3.20602 13.4197 3.43935 12.773 3.57268C12.2464 2.99935 11.5064 2.66602 10.6664 2.66602C9.0997 2.66602 7.8197 3.94602 7.8197 5.52602C7.8197 5.75268 7.84637 5.97268 7.89303 6.17935C5.5197 6.05935 3.40637 4.91935 1.9997 3.19268C1.75303 3.61268 1.61303 4.10602 1.61303 4.62602C1.61303 5.61935 2.11303 6.49935 2.88637 6.99935C2.41303 6.99935 1.97303 6.86602 1.58637 6.66602V6.68602C1.58637 8.07268 2.57303 9.23268 3.8797 9.49268C3.46019 9.60749 3.01976 9.62346 2.59303 9.53935C2.7741 10.1077 3.12873 10.605 3.60704 10.9613C4.08536 11.3176 4.66333 11.5151 5.2597 11.526C4.24879 12.3263 2.9957 12.7589 1.70637 12.7527C1.4797 12.7527 1.25303 12.7393 1.02637 12.7127C2.29303 13.526 3.7997 13.9993 5.41303 13.9993C10.6664 13.9993 13.553 9.63935 13.553 5.85935C13.553 5.73268 13.553 5.61268 13.5464 5.48602C14.1064 5.08602 14.5864 4.57935 14.973 3.99935Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.98515a54145d2e36a1cb0946014fac2a.svg";
export { ForwardRef as ReactComponent };